import React from 'react'

export default function ButtonCustom ({
  children,
  text,
  size = '',
  iconAlign = 'start',
  format,
  spacing = '',
  onClick,
  disabled,
  isSaving,
  title,
  loadingText,
  style,
  ref,
  ...props
}) {
  return (
    isSaving
      ? <button
        className={`e-btn ${format} ${spacing} ${size}`}
        disabled={isSaving}
        title="Por favor, aguarde."
        type="button"
        ref={ref}
        style={style}
        {...props}
      >
        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"/>
        <span className="e-btn__text">{loadingText || 'Salvando'}</span>
      </button>
      : <button
        className={`e-btn ${format} ${spacing} ${size}`}
        onClick={onClick}
        disabled={disabled}
        ref={ref}
        style={style}
        title={title || text}
        type="button"
        {...props}
      >
        {iconAlign === 'start' && children}
        <span className={`e-btn__text ${iconAlign === 'start' && children ? 'ml-2' : ''} ${iconAlign === 'end' && children ? 'mr-2' : ''}`}>
          {text}
        </span>
        {iconAlign === 'end' && children}
      </button>
  )
}
